import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["open", "onClick", "toggleIconComponent", "classNames", "className"];
import { cx } from "../../lib/cx.js";
import { createButtonComponent } from "../Button.js";
import { SparklesIconComponent, ChevronUpIconComponent } from "./icons.js";
export function createChatToggleButtonComponent(_ref) {
  var createElement = _ref.createElement;
  var Button = createButtonComponent({
    createElement: createElement
  });
  return function ChatToggleButton(_ref2) {
    var open = _ref2.open,
      onClick = _ref2.onClick,
      ToggleIconComponent = _ref2.toggleIconComponent,
      _ref2$classNames = _ref2.classNames,
      classNames = _ref2$classNames === void 0 ? {} : _ref2$classNames,
      className = _ref2.className,
      props = _objectWithoutProperties(_ref2, _excluded);
    var defaultIcon = open ? createElement(ChevronUpIconComponent, {
      createElement: createElement,
      width: 28,
      height: 28
    }) : createElement(SparklesIconComponent, {
      createElement: createElement,
      width: 28,
      height: 28
    });
    return createElement(Button, _extends({
      variant: "primary",
      size: "md",
      iconOnly: true,
      className: cx('ais-ChatToggleButton', open && 'ais-ChatToggleButton--open', classNames.root, className),
      onClick: onClick
    }, props), ToggleIconComponent ? createElement(ToggleIconComponent, {
      isOpen: open
    }) : defaultIcon);
  };
}